import {GetExamResultsUrl} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetExamResultsUrl} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetExamResultsUrl = (): GetExamResultsUrl =>
	new RemoteGetExamResultsUrl(
		makeBFFApiUrl(ExternalLinkPoint.examResults),
		makeAuthorizeHttpClientDecorator(),
	);
